import Footer from './components/Footer';
import LandingNav from './components/LandingNav';
import { footerNavigation } from './contentSections';

export default function TermsOfServicePage() {
  return (
    <div className='bg-background text-foreground'>
      <LandingNav />
      <main className='mx-auto max-w-3xl px-6 py-32 lg:px-8'>
        <h1 className='text-4xl font-bold mb-2'>Terms of Service</h1>
        <p className='text-sm text-muted-foreground mb-10'>Last updated: March 2026</p>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>1. Acceptance of Terms</h2>
          <p className='text-muted-foreground leading-relaxed'>
            By accessing or using App, you agree to be bound by these Terms of Service. If you
            do not agree to these terms, please do not use the platform.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>2. Use of the Platform</h2>
          <p className='text-muted-foreground leading-relaxed'>
            App is a community portal that allows organizations and individuals to post content,
            share announcements, list services, and connect with the broader Member community. You
            agree to use the platform only for lawful purposes and in a manner that does not infringe
            the rights of others.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>3. User-Generated Content</h2>
          <p className='text-muted-foreground leading-relaxed mb-3'>
            App is a platform that hosts content posted by users and organizations. We do not
            author, review, verify, or endorse any content submitted by users. All content — including
            announcements, event listings, buy/sell posts, job offers, notices, and any other
            user-generated material — is the sole responsibility of the person or organization that
            posted it.
          </p>
          <p className='text-muted-foreground leading-relaxed mb-3'>
            App is not liable for any loss, harm, or damage arising from content posted by users,
            including but not limited to inaccurate information, fraudulent listings, offensive
            material, or any transactions conducted between users.
          </p>
          <p className='text-muted-foreground leading-relaxed'>
            We reserve the right to remove any content that violates these terms or our community
            guidelines at our sole discretion.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>4. Prohibited Content</h2>
          <p className='text-muted-foreground leading-relaxed mb-2'>You agree not to post content that:</p>
          <ul className='list-disc list-inside space-y-2 text-muted-foreground leading-relaxed'>
            <li>Is false, misleading, or fraudulent</li>
            <li>Is abusive, harassing, defamatory, or hateful</li>
            <li>Violates the privacy or intellectual property rights of others</li>
            <li>Contains spam, unsolicited advertisements, or malicious links</li>
            <li>Is illegal under Canadian law or applicable regulations</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>5. Transactions Between Users</h2>
          <p className='text-muted-foreground leading-relaxed'>
            App may facilitate connections between buyers, sellers, service providers, and
            community members through its portal features. Any transaction or agreement made between
            users is strictly between those parties. App is not a party to any such transaction
            and accepts no liability for any disputes, losses, or damages arising from user-to-user
            interactions.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>6. Account Responsibility</h2>
          <p className='text-muted-foreground leading-relaxed'>
            You are responsible for maintaining the confidentiality of your account credentials and
            for all activity that occurs under your account. Please notify us immediately if you
            suspect unauthorized use of your account.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>7. Limitation of Liability</h2>
          <p className='text-muted-foreground leading-relaxed'>
            To the fullest extent permitted by law, App and its operators shall not be liable
            for any indirect, incidental, special, or consequential damages arising from your use
            of the platform or any content posted on it.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>8. Changes to Terms</h2>
          <p className='text-muted-foreground leading-relaxed'>
            We may update these Terms of Service from time to time. Continued use of the platform
            after changes are posted constitutes your acceptance of the updated terms.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-xl font-semibold mb-3'>9. Contact</h2>
          <p className='text-muted-foreground leading-relaxed'>
            For questions about these Terms, please visit our{' '}
            <a href='/contact' className='text-primary hover:underline'>contact page</a>.
          </p>
        </section>
      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}



